var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolsB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17V9.31839C5 8.46399 5 8.03679 5.196 7.67839C5.3912 7.31999 5.7504 7.08879 6.4696 6.62639L8.1352 5.55599C8.5552 5.28639 8.7648 5.15119 9 5.15119C9.2352 5.15119 9.4448 5.28639 9.8656 5.55599L11.5304 6.62639C12.2496 7.08879 12.6088 7.31999 12.804 7.67839C13 8.03679 13 8.46399 13 9.31839V17M9 9.8H9.0072M16.2 17V12.3296C16.2 10.4968 15.192 10.348 13 9.8M1.8 17V12.3296C1.8 10.4968 2.808 10.348 5 9.8M1 17H17M9 17V13.8M9 4.99999V3.38559M9 3.38559V1.77599C9 1.39679 9 1.20719 9.1168 1.08959C9.4848 0.719188 11 1.59439 11.576 1.94959C12.0624 2.24879 12.2 2.84719 12.2 3.38559H9Z",
    stroke: "#23272E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolsB);
export default __webpack_public_path__ + "static/media/SchoolsB.5410a04edf6b079b230d1fbf8d8e76bc.svg";
export { ForwardRef as ReactComponent };